import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserLocation } from "../../utils/getUserLocations";
import { fetchData } from "../../utils/fetch";
import DeviceDetector from "device-detector-js";
import toast from "react-hot-toast";
import ButtonWithSound from "../ButtonWithSound/ButtonWithSound";
import Loader from "../Loader/Loader";
// import { leaderboard as leaderboardData } from "../../utils/getLeaderBoard";
// import { getLeaderBoard } from "../../utils/getLeaderBoard";
// console.log(leaderboardData);
export default function HomePage() {
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState("");
  const [highscore, setHighScore] = useState(0);
  const [apiInProgerss, setApiInProgress] = useState(false);
  // const [leaderboard, setLeaderboard] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const img = new Image();
    img.src = "/green5.jpg";
    const storedUserId = localStorage.getItem("id");
    if (storedUserId) {
      setUserId(storedUserId);
      setHighScore(localStorage.getItem("highscore") ?? 0);
      setUserName(localStorage.getItem("userName"));
    }
  }, []);

  const handleNameSubmit = async () => {
    if (apiInProgerss || !userName) return;
    try {
      setApiInProgress(true);
      const deviceDetector = new DeviceDetector();
      const device = deviceDetector.parse(navigator.userAgent);
      const user = await fetchData("post", "/adduser", {
        ...(await getUserLocation()),
        name: userName,
        device: JSON.stringify(device),
        highscore: highscore,
      });

      const newUserId = user.id;
      localStorage.setItem("id", newUserId);
      setUserId(newUserId);
      setUserName(user.name);
      localStorage.setItem("userName", user.name);
      toast.success("welcome ", user.name);
      setApiInProgress(false);
    } catch (err) {
      toast.error("Username already exists!");
      setApiInProgress(false);
    }
  };

  return (
    <div className="min-h-screen bg-green-600 flex flex-col items-center justify-center text-white">
      {!userId ? (
        <div className="p-8 bg-green-800 rounded-lg shadow-lg text-center">
          <h1 className="text-3xl mb-6">Fruit catcher</h1>
          <h2 className="text-xl mb-4">Enter Your Name</h2>
          <input
            type="text"
            className="p-3 mb-4 text-black rounded w-full"
            placeholder="Your Name"
            value={userName}
            onChange={(e) => setUserName(e.target.value.slice(0, 10))}
          />
          <ButtonWithSound
            className="bg-yellow-500 text-lg font-bold flex justify-center items-center p-3 w-full rounded-lg hover:bg-yellow-600"
            onClick={handleNameSubmit}
          >
            {apiInProgerss ? <Loader /> : "Confirm"}
          </ButtonWithSound>
        </div>
      ) : (
        <div className="p-8 bg-green-800 rounded-lg shadow-lg text-center w-11/12 md:w-2/3 lg:w-1/2">
          <h1 className="text-3xl mb-6">Hello, {userName}!</h1>
          <div className="mb-6">
            <ButtonWithSound
              className="bg-yellow-500 w-full p-4 text-xl rounded-lg font-bold hover:bg-yellow-400 mb-3"
              onClick={() => navigate("/play")}
            >
              Play
            </ButtonWithSound>
            <ButtonWithSound
              className="bg-blue-500 w-full p-4 text-xl rounded-lg font-bold hover:bg-blue-400"
              onClick={() => navigate("/help")}
            >
              Help
            </ButtonWithSound>
          </div>
          <div className="bg-green-700 p-4 rounded-lg shadow-md mb-4">
            <h2 className="text-2xl mb-2">High Score: {highscore}</h2>
          </div>
          <div
            className="bg-green-700 p-4 rounded-lg shadow-md"
            onClick={() => navigate("/leaderboard")}
          >
            <h2 className="text-2xl mb-2">Leaderboard</h2>
          </div>
        </div>
      )}
    </div>
  );
}
